
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Koppintson a „Megnyitás böngészőben…” lehetőségre`,
's182ab2d6c997515f': `Adja hozzá a kezdőképernyőjéhez a teljes élmény és a könnyű hozzáférés érdekében.`,
's224cbcec014ef6b5': `Nyomja meg a Megosztás gombot a navigációs sávban`,
's233af3b7eb5e0364': `Hozzáadás a kezdőlaphoz`,
's37a9e8aec5713460': `Több`,
's4c3161035f3a1413': `Nyomja meg a Menü gombot`,
's4e1e10a6ca408245': `Koppintson a "Hozzáadás a kezdőképernyőhöz" lehetőségre`,
's6196153c4b0c1ea0': `Telepítés`,
's633502f7cff4f847': `Nyissa meg a böngészője menüjét`,
's681e399d63311fba': `Galéria megjelenítése`,
's6d14a4f70ba4e3cf': `Nyomja meg a Menü gombot, ha nincs Megosztás ikon`,
's922329d6f6213590': `Hozzáadás a Dock-hoz`,
's9c63a79ffcc2a3a3': `Nyomja meg a "Hozzáadás a kezdőképernyőhöz" lehetőséget`,
'sa2d71bfd9525168d': `Nyomja meg a "Hozzáadás a Dock-hoz" gombot`,
'sa5ef80b4bb9b39f8': `Kevesebb`,
'sb527eca1c1d7e7be': `Nyissa meg az alkalmazáson belüli böngésző menüjét`,
'sba52286c21552a4e': `Telepítse eszközére a teljes élmény és a könnyű hozzáférés érdekében.`,
'sc16e00a7a8b2fde2': `Vissza`,
'scdaf4bbff76674c8': `Hozzáadás a kezdőképernyőhöz`,
'sd18a5b85f599ff3c': `Nyissa meg a másolt hivatkozást a Safariban`,
'se72fc3a84f9b51c3': `Koppintson a link másolásához`,
'se740f75b95a51807': `Adja hozzá a Dock-hoz a teljes élmény és a könnyű hozzáférés érdekében.`,
'sfa6c42cdf48d93d2': `Ez a böngésző azonban nem támogatja ezt a funkciót. A folytatáshoz nyissa meg a hivatkozást egy külső böngészőben.`,
'sfb78526365796a41': `Nyomja meg a "Továbbiak megtekintése" lehetőséget a Megosztás menüben`,
'sfea652f6580ff086': `Ez az oldal alkalmazásfunkcióval rendelkezik.`,
    };
  